import { RouterName } from "core/router";
import { useGoToRecipeDetail } from "modules/Recipes/hooks/recipe";
import Icon from "core/assets/icons";

export type IProps = {
  item?: any;
  image:string;
  textSearch:string;
};

// const highlightOld = (text: string, keyword: string) => {
//   if (!text || text == '') return '';
//   const regex = new RegExp(`(${keyword})`, 'gi');
//   const highlightedString = text.replace(regex, match => `<strong>${match}</strong>`);
//   console.log(keyword,'text', text, highlightedString, regex);
//   return highlightedString;
// }

const highlight = (text: string, query: string) => {
  if (!query) return text; // Nếu không có query, trả về text gốc

  // Chuẩn hóa query và text: loại bỏ khoảng trắng thừa và chuyển về chữ thường
  const normalizedQuery = query.trim().toLowerCase();
  const normalizedText = text.toLowerCase();

  // Kiểm tra xem query có tồn tại trong text không
  if (!normalizedText.includes(normalizedQuery)) {
    return text; // Nếu không tồn tại, trả về text gốc
  }

  // Tạo regex để tìm kiếm và highlight text
  const regex = new RegExp(`(${normalizedQuery})`, "gi");
  return text.replace(regex, '<strong>$1</strong>');
};

const ItemSeach = ({item, image, textSearch}:IProps) => {
  const goToDetail = useGoToRecipeDetail(RouterName.INGREDIENT_RECIPE_DETAIL);
  return (
    <div
      className=""
      onClick={() => goToDetail(item)}
    >
      <div
        key={item?.id}
        className="flex justify-between items-center mt-[21px]"
      >
        <div className="min-w-[120px] max-w-[120px] h-[90px] mr-[6px]">
          <img
            src={image ?? item?.thumbnail}
            alt={item?.name}
            className="w-full h-full object-cover rounded-[6px]"
          />
        </div>
        <div className="  h-[91px] w-[calc(100%-120px)]">
          <h2 className="text-[13px] text-[#111111] mb-[6px]" dangerouslySetInnerHTML={{ __html: highlight(item?.name, textSearch) }} />
          <p className="text-[13px] text-[#333333] line-clamp-2">
            {item?.content?.description || ""}
          </p>
          <div className="  flex mt-[7px]">
            <div className=" flex items-center mr-[12px]">
              <img src={Icon.IconClock} alt="" className=""  onClick={() =>{}} />
              <label className="text-[11px] font-medium text-[#777777] ml-[3px]">{item?.content?.cooking_duration}</label>
            </div>
            <div className="flex items-center">
              <img src={Icon.IconFire} alt="" className=""  onClick={() =>{}} />
              <label className="text-[11px] font-medium text-[#777777] ml-[3px]">{item?.content?.calories}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemSeach;
